module.exports = __webpack_public_path__ + "static/media/07-shop.d4466fc4.png";